import { useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

type TimeLeft = {
  minutes: number;
  seconds: number;
} | null;

const convertUtcToKoreanTime = (utcTime: string) => {
  const utcMoment = moment.utc(utcTime);
  const koreanMoment = utcMoment.tz('Asia/Seoul');
  return koreanMoment.toDate(); // Date 객체
};

export const useTimerFromUtc = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(null);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null); // ✅ 수정된 타입

  const startTimer = (utcString: string) => {
    const expireTime = convertUtcToKoreanTime(utcString).getTime();

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      const now = new Date().getTime();
      const diff = expireTime - now;

      if (diff > 0) {
        const minutes = Math.floor((diff / 1000 / 60) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setTimeLeft({ minutes, seconds });
      } else {
        setTimeLeft(null);
        clearInterval(timerRef.current!);
        timerRef.current = null;
      }
    }, 1000);
  };

  const resetTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setTimeLeft(null);
  };

  useEffect(() => {
    return () => {
      resetTimer();
    };
  }, []);

  return {
    timeLeft,
    startTimer,
    resetTimer
  };
};
